import React from 'react';
import styled, { css } from 'styled-components';
import { TextInput } from 'component-library-and-tools';

import { colors } from 'lib/prisma-styles';

import { TextFieldProps } from './types';

const StyledContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

const StyledTextInput = styled(TextInput)<{ errorMessage: TextFieldProps['errorMessage'] }>`
  && {
    height: 100%;
    padding: 0 1.333333333rem;
    background-color: ${colors.interactive.defaultBackground};
    border-color: ${colors.interactive.defaultBorder};

    &:focus-within {
      border-color: ${colors.interactive.defaultBorder};
    }

    ${({ isDisabled }) => isDisabled && css`
      background-color: ${colors.interactive.disabledBackground};
    `}

    ${({ errorMessage }) => errorMessage && css`
      &:focus-within {
        border-color: #d1443f;
      }
    `};
  }
`;

const StyledErrorMessage = styled.p`
  margin: 0.666666667rem 0 0;
  padding: 0.666666667rem 1rem;
  background-color: rgba(209, 68, 63, 0.2);
  border-radius: 4px;
  color: #33373d;
`;

const TextField = ({
  className,
  textInputContainerClassName,
  textInputClassName,
  errorMessage,
  ...otherProps
}: TextFieldProps) => (
  <StyledContainer className={className}>
    <StyledTextInput
      className={textInputContainerClassName}
      inputClassName={textInputClassName}
      errorMessage={errorMessage}
      {...otherProps}
    />
    {errorMessage && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
  </StyledContainer>
);

export default TextField;
